import ContinueNoConsent from "@Components/ContinueNoConsent";

export default {
  midpath: {
    name: "Consent / Registration",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      "tcpa-consent-dba": {
        name: "TCPA Consent DBA",
        type: "tcpa-consent-dba",
        removeName: true,
      },
      "tcpa-consent-text": {
        name: <span>TCPA Consent Text  <ContinueNoConsent targetPaste='tcpa-consent-text' id='tcpa-consent-text-hint' /></span>,
        type: "html",
        height: "100px",
        default: "",
      },
      "bundled-consent-text": {
        name: "Bundled Consent Text",
        type: "html",
        height: "100px",
        default: "",
      },
      "registration-consent-text": {
        name: "Registration Consent Text",
        type: "html",
        height: "100px",
        default: "",
      },
      "recording-consent-text": {
        name: "Form Recording Consent Text",
        type: "html",
        height: "100px",
        default: "",
      },
      "registration-twyne-url": {
        name: "Registration Twyne Url",
        type: "twyne-url",
        col: 5,
        default: "",
      },
      "registration-twyne-pid": {
        name: "Registration Twyne Publisher",
        type: "string",
        col: 3,
        default: "",
      },
      "registration-twyne-sid": {
        name: "Registration Twyne Source",
        type: "string",
        default: "",
        col: 3,
      },
    },
  },

  domain: {
    name: "Domain",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      force_https: {
        name: "Force Https",
        type: "boolean",
        default: "false",
        col: 6,
      },
      redirect_www: {
        name: "Redirect www to domain",
        type: "boolean",
        default: "false",
        col: 6,
      },
    },
  },

  metatag: {
    name: "Meta Tags",
    type: "has-many",
    collapsable: true,
    open: false,
    items: {
      key: {
        name: "Name",
        type: "string",
        col: 4,
      },
      value: {
        name: "Content",
        type: "string",
        col: 4,
      },
      override: {
        name: "Allowed to override",
        type: "boolean",
        default: "true",
        col: 2,
      },
    },
  },

  recaptcha: {
    name: "Recaptcha",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      recaptcha_api_key: {
        name: "Site Key",
        type: "string",
        default: "",
        col: 6,
      },
      recaptcha_api_key_server: {
        name: "Secret Key",
        type: "string",
        default: "",
        col: 6,
      },
      enable_registration: {
        name: "Enable in Registration",
        type: "boolean",
        default: true,
        col: 4,
      },
      enable_optout: {
        name: "Enable in Optout",
        type: "boolean",
        default: true,
        col: 4,
      },
      enable_unsubscribe: {
        name: "Enable in Unsubscribe",
        type: "boolean",
        default: true,
        col: 4,
      },
    },
  },
  email_verification: {
    name: "E-mail Verification",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      method: {
        name: "Verification Method",
        type: "static-list",
        default: "",
        options: {
          xverify: "XVerify",
          rxmg: "Organization Exclusive",
        },
        col: 4,
      },
      apikey: {
        name: "Api Key",
        type: "string",
        default: "",
        col: 4,
      },
      xverify_domain: {
        name: "XVerify Domain",
        type: "string",
        default: "",
        condition: ["current.method === 'xverify'"],
        col: 4,
      },
    },
  },
  xverify: {
    name: "Xverify (deprecated - use e-mail verification section)",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      xverify_apikey: {
        name: "XVerify Api Key",
        type: "string",
        default: "",
      },
      xverify_domain: {
        name: "XVerify Domain",
        type: "string",
        default: "",
      },
    },
  },
  analytics: {
    name: "Google Tag Manager",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      analytics_api_key: {
        name: "GTM ID",
        type: "string",
        default: "",
      },
    },
  },
  ezanga: {
    name: "Fraud Detection",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      ezanga_api_key: {
        name: "Anura.io API key",
        type: "string",
        default: "",
      },
    },
  },
  hotjar: {
    name: "Hotjar",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      hotjar_enable: {
        name: "Hotjar Enable",
        type: "boolean",
        default: "",
        col: 6,
      },
      hotjar_id: {
        name: "Hotjar Id",
        type: "string",
        default: "",
        col: 6,
      },
    },
  },
  jornaya: {
    name: "Jornaya",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      leadid_key: {
        name: "Leadid Campaign Key",
        type: "string",
        default: "",
        col: 6,
      },
    },
  },
  precision_samples: {
    name: "Precision Samples",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      precision_samples_apikey: {
        name: "API Key",
        type: "string",
        default: "",
        col: 6,
      },
      precision_samples_rid: {
        name: "Partner ID (RID)",
        type: "integer",
        default: "",
        col: 6,
      },
    },
  },
  cint: {
    name: "Cint Panel",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      cint_panel_key: {
        name: "Panel Key",
        type: "string",
        default: "",
        col: 4,
      },
      cint_panel_secret: {
        name: "Panel Secret",
        type: "string",
        default: "",
        col: 4,
      },
      cint_panel_pwd_field: {
        name: "Custom Field Password",
        type: "customfield-list",
        default: "",
        col: 4,
      },
    },
  },
  redirects: {
    name: "Global Redirect Fallback",
    type: "group",
    collapsable: false,
    open: false,
    items: {
      blocking_url: {
        name: "Blocking URL",
        type: "string",
        default: "",
      },
    },
  },
  lead_hoop: {
    name: "Lead Hoop",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      pre_select: {
        name: "Pre-Select Schools",
        type: "boolean",
        default: "",
        col: 3,
      },
    },
  },
  wildcard: {
    name: "Multiple Domain",
    type: "group",
    collapsable: true,
    open: false,
    items: {
      wildcard: {
        name: "Enable Multiple Domain",
        type: "wildcard",
        col: 5,
      },
    },
  },
}
